import React, { useState } from 'react';
import { firebase } from '../firebase/index';
import { InputFile } from './InputFile';

export const InputFileWrapper = ({ type, filename, name, document, updateDocument, label, sessionID }) => {

    console.log("in InputFileWrapper ===>", sessionID);
    const value = document[name] || '';
    const isEmpty = !value.length;
    let storageRef = null;

    let [link, setLink] = useState('');
    let [percentage, setPercentage] = useState(isEmpty ? 0 : 100);
    let [status, setStatus] = useState(isEmpty ? 'empty' : 'complete');
    let [href, setHref] = useState(null);

    if(filename) {
        filename = filename.replaceAll('{sessionID}', sessionID);
    }

    if(!isEmpty) {
      storageRef = firebase.storage().ref(`quietrent-development/${sessionID}/${value}`);
      storageRef.getDownloadURL().then((url) => {
        setHref(url);
      })
    }


  
    function update(e) {
      const file = e.target?.files[0];
      filename = filename || file?.name;
      if (!filename) return;

      storageRef = firebase.storage().ref(`quietrent-development/${sessionID}/${filename}`);
      let task = storageRef.put(file);
  
      setStatus('loading');
  
      task.on('state_changed', function (snapshot) {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //console.log('Upload is ' + progress + '% done');
        setPercentage(progress);
      }, function (error) {
        console.log(error);
        setStatus('error');
      }, function () {
        setStatus('complete');
        updateDocument({ [name]: filename });
      });
    }

    const props = { percentage, isEmpty, label, type, status, href, update };
  
    return (<InputFile {...props}></InputFile>)
  
  }